/**
 * @generated SignedSource<<740cbdd666956770eed1f9fd1580ea40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATSolvedProblemUserAnswerUpdateInput = {
  currentAnswer: number;
  previousAnswer: number;
  sequence: number;
};
export type TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$variables = {
  input: MATSolvedProblemUserAnswerUpdateInput;
};
export type TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$data = {
  readonly solvedProblemUserAnswerUpdate: {
    readonly currentAnswerCount: number;
    readonly previousAnswerCount: number;
  };
};
export type TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation = {
  response: TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$data;
  variables: TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATSolvedProblemUserAnswer",
    "kind": "LinkedField",
    "name": "solvedProblemUserAnswerUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previousAnswerCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentAnswerCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "83f7b28f38294be661d8d775f6150df0",
    "id": null,
    "metadata": {},
    "name": "TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation TaskAnswerChangeHistorySolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation(\n  $input: MATSolvedProblemUserAnswerUpdateInput!\n) {\n  solvedProblemUserAnswerUpdate(input: $input) {\n    previousAnswerCount\n    currentAnswerCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "b712a628fe9808816824fb9199969112";

export default node;
